var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',[_c('span',[_vm._v(_vm._s(_vm.$t('reporte.reparar')))])]),_c('el-main',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.reparar()}}},[_vm._v(_vm._s(_vm.$t('reporte.reparar')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }